/*@ngInject*/
module.exports = function($rootScope, $uibModal, publicObjectsService) {
    return {
        scope: {
            objects: '=',
            isScrollable: '=',
            isHomeView: '=',
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
            let vm = this;
            vm.selectedObject = {};
            vm.objectMapModalOpen = false;
            const nrOfObjectsDisplayed = 50;
            vm.nrOfShowedObjects = nrOfObjectsDisplayed;

            vm.showMore = () => {
                let objectsFilter = JSON.parse(localStorage.getItem('objectsFilter'));
                objectsFilter.filter.limit += nrOfObjectsDisplayed;
                localStorage.setItem('objectsFilter', JSON.stringify(objectsFilter));
                let filter = objectsFilter.filter;
                filter.useSession = true;
                publicObjectsService.getObjectsBySearch(filter, null).then(result => {
                    vm.nrOfShowedObjects = filter.limit;
                    vm.objects.push(...result.data);
                });
            };

            vm.showOnMap = (object) => {
                $uibModal.open({
                    template: require('./object-map-modal.directive.html'),
                    controller: require('./object-map-modal.directive'),
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'center-modal',
                    resolve: {
                        data () {
                            return object;
                        }
                    }
                });
                $rootScope.isModalOpen = true;
            };
        },
        template: require('./object-results-listview.directive.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-results-listview.directive.js
 **/